query GetDataUploads($page: Int, $limit: Int) {
  dataUploads(page: $page, limit: $limit) {
    collection {
      id
      uploadType
      status
      totals {
        totalRows
        errors
        potentialDuplicates
        ready
        created
      }
      errorMessage
      user {
        id
        name
      }
      createdAt
      updatedAt
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
